import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
//import { Alert } from '@mui/material';
//import { type } from '@testing-library/user-event/dist/type';
import Progress from './Progress';
import { apiPath } from "../src/services/apiConfig";

function Seotags() {

  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displaySeotag, setDisplaySeoTag] = useState('none');
  const [displayUpdSeoTag, setDisplayUpdSeoTag] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [pageid, setPageId] = useState('');
  const [title, setTitle] = useState('')
  const [metaTitle, setMetaTitle] = useState('')
  const [ogTitle, setOGTitle] = useState('')
  const [metaDesc, setMetaDesc] = useState('')
  //  const [uid, setUID] = useState('');
  const [verfied, setVerfied] = useState(true);
  const [updPgId, setUpdPgId] = useState('');
  const [updTitle, setUpdTitle] = useState('');
  const [updMetaTitle, setUpdMetaTitle] = useState('');
  const [updOGTitle, setUpdOGTitle] = useState('');
  const [updMetaDesc, setUpdMetaDesc] = useState('');
  const [id, setID] = useState('');
  // const [uidErr, setUIDErr] = useState('');
  // const [Err, SetErr] = useState([]);
  const [isloading, setIsLoading] = useState(false)
  const [IsDisabled, setIsDisabled] = useState(false)
  const formRef = useRef();

  let txt = "";

  useEffect(() => {
    getSeoTag()
  }, [])

  const handleSubmit = () => {
    verifySeoTag()
    if (verfied) {
      formRef.current.reset();
    }
  }

  function openSeoTag() {
    setDisplaySeoTag('block')
  }

  function closeSeoTag() {
    setDisplaySeoTag('none')
  }

  function openUpdSeoTag() {
    setDisplayUpdSeoTag('block')
  }

  function closeUpdSeoTag() {
    setDisplayUpdSeoTag('none')
  }

  async function updateSeoTag(id) {
    //alert(id+','+updSpecialityName+","+updSpecialityType)

    let result = await fetch(apiPath + "SeoTags/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "title": updTitle,
        "meta_title": updMetaTitle,
        "og_title": updOGTitle,
        "meta_description": updMetaDesc
      })
    });

    result = await result.json();

    showSwal(result.success, result.message)

    if (isloading) {
    } else {
      setIsLoading(false)
    }

    getSeoTag()
  }

  async function deleteSeoTag(id) {

    let result = await fetch(apiPath + "SeoTags/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getSeoTag()
  }



  async function updateOperation(id) {

    let result = await fetch(apiPath + "SeoTags/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",

          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },

      });

    result = await result.json();

    //console.warn(result.data)

    setUpdPgId(result.data.pageid);
    setUpdTitle(result.data.title);
    setUpdMetaTitle(result.data.meta_title);
    setUpdOGTitle(result.data.og_title);
    setUpdMetaDesc(result.data.meta_description);
    setID(result.data.id)

    openUpdSeoTag();
  }


  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          //        alert(usrRole)
          //        if (usrRole === "admin"){
          deleteSeoTag(id);
          //        }else{
          //          swal("You are not authorized to delete!");
          //        }
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL SEO Tag (for initial screen)*/ 

  async function getSeoTag() {
    let result = await fetch(apiPath + "SeoTags",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
 //     setUID(item)
    }
  }
  */}

  function verifySeoTag() {
    setVerfied(true)
    addSeoTag()
  }

  {/*ADD A NEW SEO TAG*/ }
  async function addSeoTag() {
    //    alert('Add,'+departmentName)
    if (verfied) {
      setIsDisabled(true)
      setIsLoading(true)

      let result = await fetch(apiPath + "SeoTags", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "pgId": pageid,
          "title": title,
          "meta_title": metaTitle,
          "og_title": ogTitle,
          "meta_description": metaDesc
        })

      });
      result = await result.json();
      console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      setIsDisabled(false)

      showSwal(result.success, result.message)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
      getSeoTag()
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>


      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>

          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">SEO Tags</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openSeoTag} type="button" name="button"
                className="btn solid round">Create SEO Tags</button>
            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="5%">Page-Id</th>
                  <th className="th-border left" width="15%">Title</th>
                  <th className="th-border left" width="15%">Meta-Title</th>
                  <th className="th-border left" width="15%">OG-Title</th>
                  <th className="th-border left" width="55%">Meta Description</th>
                  <th className="th-border left" width="5%">Edit</th>
                  <th className="th-border left" width="5%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.pgId}</td>
                          <td className="left">{item.title}</td>
                          <td className="left">{item.meta_title}</td>
                          <td className="left">{item.og_title}</td>
                          <td className="left">{item.meta_description}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW USER */}

          <div id="newdept" style={{ 'display': displaySeotag }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeSeoTag}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Specility</h2>
                  <br></br>
                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Page Id" onChange={(e) => setPageId(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Title" onChange={(e) => setTitle(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Meta Title Name" onChange={(e) => setMetaTitle(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="OG Title" onChange={(e) => setOGTitle(e.target.value)} />

                  <textarea className="box small" autoComplete="off"
                    placeholder="Meta Description" onChange={(e) => setMetaDesc(e.target.value)} />

                  <br></br>
                  <button disabled={IsDisabled} onClick={handleSubmit} type="button"
                    className="btn solid round">Add SEO Tag</button>
                  {
                    (isloading === true ?
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdSeoTag }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdSeoTag}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit SEO Tags</h2><br /><br />

                  <input type="hidden" value={id} />

                  <input type="text" className="box small"
                    placeholder="Name of the Page Id" readonly="readonly" value={updPgId} />

                  <input type="text" className="box small"
                    placeholder="Name of the Title" onChange={(e) => setUpdTitle(e.target.value)}
                    value={updTitle} />

                  <input type="text" className="box small"
                    placeholder="Name of the Meta Title" onChange={(e) => setUpdMetaTitle(e.target.value)}
                    value={updMetaTitle} />

                  <input type="text" className="box small"
                    placeholder="Name of the OG Title" onChange={(e) => setUpdOGTitle(e.target.value)}
                    value={updOGTitle} />

                  <textarea className="box small"
                    placeholder="Name of the Page Id" onChange={(e) => setUpdMetaDesc(e.target.value)}
                    value={updMetaDesc} />

                  <br></br>
                  <button onClick={() => { updateSeoTag(id) }} type="button"
                    className="btn solid round">Update SEO Tag</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Seotags;
